import preprocessRange from './preprocessRange';

/**
 * Creates a `Range` object from the HTML element containing the suggestion.
 *
 * @param {HTMLElement | null} suggestionContainer - The HTML container holding the element with the suggestion.
 * @param {string} suggestionElementClassName - The class name of the suggestion element.
 * @returns {Range | undefined} A range that surrounds the HTML element containing the suggestion, or `undefined` if range creation fails.
 */
const makeRangeFromSuggestion = (
  suggestionContainer: HTMLElement | null,
  suggestionElementClassName: string,
): Range | undefined => {
  if (!suggestionContainer) {
    return undefined;
  }
  const contentAreas = Array.from(
    suggestionContainer.getElementsByClassName(suggestionElementClassName),
  );
  if (contentAreas.length <= 0) {
    return undefined;
  }
  const rangeStart = contentAreas[0];
  const rangeEnd = contentAreas[contentAreas.length - 1];
  const range = document.createRange();
  if (!rangeStart || !rangeEnd) {
    return undefined;
  }
  range.setStartBefore(rangeStart);
  range.setEndAfter(rangeEnd);

  contentAreas.forEach((contentArea) => {
    const contentAreaChildNodes = Array.from(contentArea.childNodes);
    contentArea.replaceWith(...contentAreaChildNodes);
    if (contentArea === rangeStart) {
      range.setStartBefore(contentAreaChildNodes[0]);
    }
    if (contentArea === rangeEnd) {
      range.setEndAfter(
        contentAreaChildNodes[contentAreaChildNodes.length - 1],
      );
    }
  });
  suggestionContainer.normalize();
  return preprocessRange(range, document);
};

export default makeRangeFromSuggestion;
